import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "./Product_ratings.css";
import StarRatings from "react-star-ratings";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Form } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Blue_Round_Btn from "../../common-components/common-btn/blue_round_btn/Blue_Round_Btn";
import Review_Modal from "../../common-components/common-modals/review_modal/Review_Modal";
import { formatDate } from "../../../utils/common";

const Product_ratings = ({avgrating,all_review}) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [showModal, setShowModal] = useState(false);
 

  return (
    <>
      <section className="Product_ratings_div">
        <div className="row">
          <div className="col-lg-4 mb-lg-0 mb-4">
            <div className="leftsec">
              <div className="row">
                <div className="col-5 text-center">
                  <h1 className="ratecount">{avgrating?.average_rating}</h1>
                </div>
                <div className="col-7 text-center my-auto">
                  <StarRatings
                    rating={Number(avgrating?.average_rating || 0)}
                    starDimension="25px"
                    starSpacing="1px"
                    starRatedColor="#FFC107"
                  />
                  <p className="basedp">Based on {avgrating?.total_counts} Review</p>
                </div>
              </div>
              <button className="reviewbtn" onClick={() => setShowModal(true)}>
                Write Review
              </button>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="slider_sec">
              <Swiper
                slidesPerView={1}
                spaceBetween={10}
                pagination={{
                  clickable: true,
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  575: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  1024: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                }}
                modules={[Pagination]}
                className="mySwiper"
              >
                {all_review?.map((val)=>
                <SwiperSlide>
                  <div className="slider_div">
                    <div className="flexdivname">
                      <div className="img_div">
                        <img
                          className="clientimg"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/product-descrption/client.png"
                          }
                        />
                      </div>
                      <div className="namediv">
                        <p className="clientname">
                          {val?.User?.name}
                          {/* <span>(Verified Customer)</span> */}
                        </p>
                        <p className="clientname">
                          <StarRatings
                            rating={val?.ratings}
                            starDimension="17px"
                            starSpacing="1px"
                            starRatedColor="#FFC107"
                          />{" "}
                          <span>{formatDate(val?.createdAt)}</span>
                        </p>
                      </div>
                    </div>
                    <p className="clientreview">
                      {" "}
                      {val?.review}
                    </p>
                  </div>
                </SwiperSlide>)}

                {/* <SwiperSlide>
                  <div className="slider_div">
                    <div className="flexdivname">
                      <div className="img_div">
                        <img
                          className="clientimg"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/product-descrption/client.png"
                          }
                        />
                      </div>
                      <div className="namediv">
                        <p className="clientname">
                          Abhishek Shinde <span>(Verified Customer)</span>
                        </p>
                        <p className="clientname">
                          <StarRatings
                            rating={2.403}
                            starDimension="17px"
                            starSpacing="1px"
                            starRatedColor="#FFC107"
                          />{" "}
                          <span>12/05/2025</span>
                        </p>
                      </div>
                    </div>
                    <p className="clientreview">
                      {" "}
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      do eiusmod tempor incididunt ut labore et dolore mag.
                    </p>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="slider_div">
                    <div className="flexdivname">
                      <div className="img_div">
                        <img
                          className="clientimg"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/product-descrption/client.png"
                          }
                        />
                      </div>
                      <div className="namediv">
                        <p className="clientname">
                          Abhishek Shinde <span>(Verified Customer)</span>
                        </p>
                        <p className="clientname">
                          <StarRatings
                            rating={2.403}
                            starDimension="17px"
                            starSpacing="1px"
                            starRatedColor="#FFC107"
                          />{" "}
                          <span>12/05/2025</span>
                        </p>
                      </div>
                    </div>
                    <p className="clientreview">
                      {" "}
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      do eiusmod tempor incididunt ut labore et dolore mag.
                    </p>
                  </div>
                </SwiperSlide>

                <SwiperSlide>
                  <div className="slider_div">
                    <div className="flexdivname">
                      <div className="img_div">
                        <img
                          className="clientimg"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/product-descrption/client.png"
                          }
                        />
                      </div>
                      <div className="namediv">
                        <p className="clientname">
                          Abhishek Shinde <span>(Verified Customer)</span>
                        </p>
                        <p className="clientname">
                          <StarRatings
                            rating={2.403}
                            starDimension="17px"
                            starSpacing="1px"
                            starRatedColor="#FFC107"
                          />{" "}
                          <span>12/05/2025</span>
                        </p>
                      </div>
                    </div>
                    <p className="clientreview">
                      {" "}
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      do eiusmod tempor incididunt ut labore et dolore mag.
                    </p>
                  </div>
                </SwiperSlide> */}
              </Swiper>
            </div>
          </div>
        </div>

        <Review_Modal show={showModal} onHide={() => setShowModal(false)} />
      </section>
    </>
  );
};

export default Product_ratings;
